export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/journal-party-journal-prompts/id1661995476';

export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.pevr2wv0gtxs.p3gfapng2app';

const NATIVE_PREMIUM_RETURN_URL = 'journalparty://welcome-premium';

type SearchParamsReader = Pick<URLSearchParams, 'get'>;

/**
 * Build a credential-free handoff from the hosted checkout success screen to
 * the native app. Provider references stay server-side: the app rechecks the
 * signed-in account instead of trusting identifiers carried by a deep link.
 */
export function buildNativePremiumHandoffUrl(searchParams: SearchParamsReader): string {
  const url = new URL(NATIVE_PREMIUM_RETURN_URL);
  url.searchParams.set('checkout', 'success');

  const provider = searchParams.get('provider');
  if (provider === 'stripe' || provider === 'paypal') {
    url.searchParams.set('provider', provider);
  }

  if (searchParams.get('onboarding') === 'complete') {
    url.searchParams.set('onboarding', 'complete');
  }

  return url.toString();
}
